import { __decorate } from 'tslib';
import * as i0 from '@angular/core';
import { Component, ViewEncapsulation, Input, HostBinding, NgModule } from '@angular/core';
import { Required, Default } from '@rogers/cdk/common/decorators';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as i1 from '@rogers/cdk/core';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';

const prefixMap = {
    rogers: 'rds-icon-',
    fido: 'fds-icon-',
    chatr: 'cds-icon-',
    r4b: 'sds-icon-',
};
class IconComponent {
    constructor(configService, cdr) {
        this.configService = configService;
        this.cdr = cdr;
        this.destroy$ = new Subject();
    }
    get hasEmptyName() {
        return this.name === '';
    }
    get classes() {
        const classList = [];
        if (this.name !== '') {
            classList.push(this.name.startsWith(prefixMap[this.brand])
                ? this.name
                : prefixMap[this.brand] + this.name);
            classList.push(this.color ? 'ds-color-' + this.color : '');
        }
        return classList.join(' ');
    }
    shouldPathsRender(iconName) {
        return (this.name === iconName || this.name === prefixMap[this.brand] + iconName);
    }
    get brand() {
        return this.configService.config$.getValue()?.brand;
    }
    ngOnInit() {
        this.configService.config$.pipe(takeUntil(this.destroy$)).subscribe((c) => {
            this.cdr.markForCheck();
        });
    }
    ngOnDestroy() {
        this.destroy$.next(void 0);
        this.destroy$.complete();
    }
}
IconComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: IconComponent, deps: [{ token: i1.CDKCoreService }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
IconComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: IconComponent, selector: "ds-icon", inputs: { name: "name", color: "color", caption: "caption", ariaHidden: "ariaHidden", size: "size" }, host: { properties: { "class.-size-24": "size === \"24\"", "class.-size-32": "size === \"32\"", "class.-size-48": "size === \"48\"", "class.d-none": "this.hasEmptyName" } }, ngImport: i0, template: "<span\n  role=\"img\"\n  class=\"ds-icon d-inline-flex\"\n  [ngClass]=\"classes\"\n  [attr.aria-label]=\"caption || null\"\n  [attr.aria-hidden]=\"!caption ? ariaHidden : false\"\n>\n  <ng-container *ngIf=\"shouldPathsRender('mastercard')\">\n    <span class=\"path1\"></span>\n    <span class=\"path2\"></span>\n    <span class=\"path3\"></span>\n  </ng-container>\n  <ng-container *ngIf=\"shouldPathsRender('va')\">\n    <span class=\"path1\"></span>\n    <span class=\"path2\"></span>\n    <span class=\"path3\"></span>\n    <span class=\"path4\"></span>\n    <span class=\"path5\"></span>\n    <span class=\"path6\"></span>\n  </ng-container>\n</span>\n", directives: [{ type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], encapsulation: i0.ViewEncapsulation.None });
__decorate([
    Required()
], IconComponent.prototype, "name", void 0);
__decorate([
    Default(true)
], IconComponent.prototype, "ariaHidden", void 0);
__decorate([
    Default('24')
], IconComponent.prototype, "size", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: IconComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ds-icon', host: {
                        '[class.-size-24]': 'size === "24"',
                        '[class.-size-32]': 'size === "32"',
                        '[class.-size-48]': 'size === "48"',
                    }, encapsulation: ViewEncapsulation.None, template: "<span\n  role=\"img\"\n  class=\"ds-icon d-inline-flex\"\n  [ngClass]=\"classes\"\n  [attr.aria-label]=\"caption || null\"\n  [attr.aria-hidden]=\"!caption ? ariaHidden : false\"\n>\n  <ng-container *ngIf=\"shouldPathsRender('mastercard')\">\n    <span class=\"path1\"></span>\n    <span class=\"path2\"></span>\n    <span class=\"path3\"></span>\n  </ng-container>\n  <ng-container *ngIf=\"shouldPathsRender('va')\">\n    <span class=\"path1\"></span>\n    <span class=\"path2\"></span>\n    <span class=\"path3\"></span>\n    <span class=\"path4\"></span>\n    <span class=\"path5\"></span>\n    <span class=\"path6\"></span>\n  </ng-container>\n</span>\n" }]
        }], ctorParameters: function () { return [{ type: i1.CDKCoreService }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { name: [{
                type: Input
            }], color: [{
                type: Input
            }], caption: [{
                type: Input
            }], ariaHidden: [{
                type: Input
            }], size: [{
                type: Input
            }], hasEmptyName: [{
                type: HostBinding,
                args: ['class.d-none']
            }] } });

class IconModule {
}
IconModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: IconModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
IconModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: IconModule, declarations: [IconComponent], imports: [CommonModule], exports: [IconComponent] });
IconModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: IconModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: IconModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [IconComponent],
                    imports: [CommonModule],
                    exports: [IconComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { IconComponent, IconModule };
